import React from 'react';
import { StarIcon } from 'lucide-react';
type TestimonialCardProps = {
  quote: string;
  name: string;
  role: string;
  age: string;
  location: string;
};
export function TestimonialCard({
  quote,
  name,
  role,
  age,
  location
}: TestimonialCardProps) {
  return <article className="flex h-full flex-col rounded-2xl border border-stone-200 bg-white p-8 shadow-sm" data-id="element-12">
      <div className="mb-4 flex gap-1" aria-label="5 out of 5 stars" data-id="element-13">
        {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-14" />)}
      </div>
      <blockquote className="mb-6 flex-grow text-lg italic text-stone-700" data-id="element-15">
        “{quote}”
      </blockquote>
      <footer className="mt-auto border-t border-stone-100 pt-4" data-id="element-16">
        <p className="font-bold text-stone-900" data-id="element-17">{name}</p>
        <p className="mt-1 text-sm text-stone-500" data-id="element-18">
          {role} · {age} years old · {location}
        </p>
      </footer>
    </article>;
}